export type Mark = 'X' | 'O';
export type Cell = Mark | null;
export type Board = readonly [Cell, Cell, Cell, Cell, Cell, Cell, Cell, Cell, Cell];
export type CellIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type GameStatus = 'playing' | 'won' | 'draw';

export interface GamePayload {
  id: string;
  x: string;
  o: string;
  s: Mark;
  m: CellIndex[];
}

export interface GameState {
  id: string;
  nameX: string;
  nameO: string;
  starter: Mark;
  moves: CellIndex[];
  board: Board;
  turn: Mark;
  status: GameStatus;
  winner: Mark | null;
  winningLine: readonly CellIndex[] | null;
}

export const WIN_LINES: readonly (readonly CellIndex[])[] = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
] as const;

export const EMPTY_BOARD: Board = [null, null, null, null, null, null, null, null, null];
